import { axiosRequest } from '@/plugins/axios-common'

import { handleError } from '@/store/handle-error'

export const EOIRCaseInfoActions = {
  getEOIRCaseInfoListOptions: async _ => {
    return axiosRequest.
      get('/eoir_case_info/options').
      then(({ data }) => data).
      catch(handleError)
  },

  getEOIRCaseInfoSubscriptions: async (_, filters) => {
    return axiosRequest.
      get('/eoir_case_info', { params: filters }).
      then(({ data }) => data).
      catch(handleError)
  },

  getEOIRCaseInfoSubscriptionsExport: async (_, filters) => {
    return axiosRequest.
      get('/eoir_case_info/export', { params: filters }).
      then(({ data }) => data).
      catch(handleError)
  },

  getEOIRCaseInfoSubscription: async (_, id) => {
    return axiosRequest.
      get(`/eoir_case_info/${id}`).
      then(({ data }) => data).
      catch(handleError)
  },

  createEOIRCaseInfoSubscription: async (_, { legalCaseId, partyId, caseInfo }) => {
    return axiosRequest.
      post('/eoir_case_info', {
        case_info: caseInfo,
        legal_case_id: legalCaseId,
        party_id: partyId,
      }).
      then(({ data }) => data).
      catch(handleError)
  },

  updateEOIRCaseInfoSubscription: async (_, params) => {
    return axiosRequest.
      post(`/eoir_case_info/${params.id}`, { eoir_case_info_subscription: params }).
      then(({ data }) => data).
      catch(handleError)
  },

  updateEOIRCaseInfo: async (_, { caseInfo, id }) => {
    return axiosRequest.
      put('/eoir_case_info', { case_info: caseInfo, id }).
      then(({ data }) => data).
      catch(handleError)
  },

  reviewEOIRCaseInfoSubscription: async (_, id) => {
    return axiosRequest.
      post(`/eoir_case_info/${id}/review`).
      then(({ data }) => data).
      catch(handleError)
  },
}
